// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"161":"4d0cb2524595e6ed","315":"224f7658a4c38083","423":"fdcf5748a02e9ced","985":"c06a46f3038f3256"}[chunkId] + ".js";
};